// import hooks
import { isNil } from 'ramda';
import { useQuery } from 'react-query';

// import api's and mutations
import { getCLAYearSettings, getDccOptions } from 'RestAPIs/admin';
import { getDutyHourTypesByDcc } from 'RestAPIs/dutyHourTypes';

// import types
import { DutyHourType } from 'components/admin-portal/Tables/Settings/DutyHourTypes/types';

// import utils
import { createOptions } from '../CLASettings.utils';

export const useGetCLASettings = (options?: Record<string, unknown>) =>
  useQuery(
    ['claYears'],
    async () => {
      const { data } = await getCLAYearSettings();
      if (isNil(data)) return [];
      return data;
    },
    options
  );

export const useGetDhtOptions = (
  targetId?: keyof Pick<DutyHourType, 'id' | 'dutyTypeId' | 'code'>,
  options?: Record<string, unknown>
) =>
  useQuery(
    ['DHTClaSettings', 'list'],
    async () => {
      const { data } = await getDutyHourTypesByDcc();
      if (isNil(data)) return [];
      return data.map((dcc) => {
        return {
          value: targetId ? dcc[targetId] : dcc.id,
          label: dcc.description
        };
      });
    },
    options
  );

export const useGetDccOptions = (options?: Record<string, unknown>) =>
  useQuery(
    ['duty-calculation-codes'],
    async () => {
      const { data } = await getDccOptions();
      if (isNil(data)) return [];
      return createOptions(data);
    },
    options
  );
